import { useMap } from 'react-leaflet'

const ChangeView = ({ center, origin, map_bounds, map_path }) => {
  const map = useMap()

  let zoom = 13
  if (center !== null) {
    switch (origin) {
      case 'tracks':
        if (map.getZoom() !== undefined)
          map.setView(map.getCenter(), map.getZoom())
        else map.fitBounds(map_bounds)
        break
      case 'modify':
        map.fitBounds(map_bounds)
        break
      case 'meteo':
        map.fitBounds(map_bounds, { padding: [40, 40] })
        break
      case 'try':
        /* zoom = 16
        map.setView(center, zoom) */
        map.fitBounds(map_bounds, { padding: [10, 10] })
        break
      case 'sessions':
        map.setView(center, zoom)
        break
      default:
        break
    }
  }

  return null
}

export default ChangeView
